/**
 * Shared metadata + helpers for the Updates / blog area.
 * Kept in /lib so backend categories stay consistent across pages.
 */
export const CATEGORIES = [
    { slug: "produkt",   label: "Produkt",   color: "sky"     },
    { slug: "branche",   label: "Branche",   color: "violet"  },
    { slug: "cases",     label: "Cases",     color: "emerald" },
    { slug: "tutorials", label: "Tutorials", color: "amber"   },
];

export function getCategory(slug) {
    return CATEGORIES.find((c) => c.slug === slug) || {
        slug, label: slug, color: "slate",
    };
}

const CHIP_CLASSES = {
    sky:     "bg-sky-50 text-sky-700 border-sky-200",
    violet:  "bg-violet-50 text-violet-700 border-violet-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber:   "bg-amber-50 text-amber-800 border-amber-200",
    slate:   "bg-slate-50 text-slate-700 border-slate-200",
};

const DOT_CLASSES = {
    sky:     "bg-sky-500",
    violet:  "bg-violet-500",
    emerald: "bg-emerald-500",
    amber:   "bg-amber-500",
    slate:   "bg-slate-500",
};

export function chipClasses(color) {
    return CHIP_CLASSES[color] || CHIP_CLASSES.slate;
}

export function dotClasses(color) {
    return DOT_CLASSES[color] || DOT_CLASSES.slate;
}

/** Format ISO yyyy-mm-dd → "5. maj 2026" (Danish). */
export function formatDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("da-DK", {
        day: "numeric", month: "long", year: "numeric",
    });
}
